import { NavigationConfig, NavigationItem } from 'types/navigation';
import { navigationItems } from './navigationItems';

export const navigationConfig: NavigationConfig = {
  items: navigationItems,
};

export const getNavigationItemsForUser = (
  userType: 'guest' | 'candidate' | 'employer' | null,
  isAdmin: boolean
): NavigationItem[] => {
  const currentUserType = userType || 'guest';

  const filterItems = (items: NavigationItem[]): NavigationItem[] => {
    return items
      .filter(
        item =>
          !item.userTypes ||
          item.userTypes.includes(currentUserType) ||
          (item.userTypes.includes('admin') && isAdmin)
      )
      .filter(item => item.showInNavigation !== false)
      .map(item => ({
        ...item,
        children: item.children ? filterItems(item.children) : undefined,
      }))
      .filter(item => item.path || (item.children && item.children.length > 0));
  };

  return filterItems(navigationConfig.items);
};

export const getAllRoutes = (
  userType: 'guest' | 'candidate' | 'employer' | null,
  isAdmin: boolean
): NavigationItem[] => {
  const currentUserType = userType || 'guest';

  const extractRoutes = (items: NavigationItem[]): NavigationItem[] => {
    const routes: NavigationItem[] = [];

    items.forEach(item => {
      if (
        !item.userTypes ||
        item.userTypes.includes(currentUserType) ||
        (item.userTypes.includes('admin') && isAdmin)
      ) {
        if (item.path && item.component) {
          routes.push(item);
        }
        if (item.children) {
          routes.push(...extractRoutes(item.children));
        }
      }
    });

    return routes;
  };

  return extractRoutes(navigationConfig.items);
};

export const getMainNavigationItems = (
  userType: 'guest' | 'candidate' | 'employer' | null,
  isAdmin: boolean
): NavigationItem[] => {
  return getNavigationItemsForUser(userType, isAdmin).filter(
    item =>
      item.id !== 'auth' &&
      item.id !== 'catch-all' &&
      item.showInNavigation !== false &&
      (item.path || (item.children && item.children.length > 0))
  );
};

export const getUserMenuItems = (
  userType: 'candidate' | 'employer' | 'guest' | null,
  isAdmin: boolean
): NavigationItem[] => {
  if (!userType) return [];

  const extractUserMenuItems = (items: NavigationItem[]): NavigationItem[] => {
    const menuItems: NavigationItem[] = [];

    items.forEach(item => {
      if (!item.userTypes || item.userTypes.includes(userType) || isAdmin) {
        if (item.showInUserMenu) {
          menuItems.push(item);
        }
        if (item.children) {
          menuItems.push(...extractUserMenuItems(item.children));
        }
      }
    });

    return menuItems;
  };

  return extractUserMenuItems(navigationConfig.items);
};

export const getUserMenuItemsByGroup = (
  userType: 'candidate' | 'employer' | 'guest' | null,
  isAdmin: boolean
): { [key: string]: NavigationItem[] } => {
  const menuItems = getUserMenuItems(userType, isAdmin);
  const grouped: { [key: string]: NavigationItem[] } = {
    profile: [],
    account: [],
    system: [],
    admin: [],
    other: [],
  };

  menuItems.forEach(item => {
    const group = item.userMenuGroup || 'other';
    if (!grouped[group]) {
      grouped[group] = [];
    }
    grouped[group].push(item);
  });

  return grouped;
};
